import { Typography, Box, Button } from '@mui/material';
import { useStyles as useHomePageStyles } from './HomePage.styles';
import { IRequestType } from '../../constants/interfaces';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import { useStyles } from './HelperComponents.styles';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import GavelIcon from '@mui/icons-material/Gavel';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import EditNoteIcon from '@mui/icons-material/EditNote';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import DescriptionIcon from '@mui/icons-material/Description';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import {
  colors,
  cssSpacingLg,
  cssMinButtonWidth,
  typography,
  cssSpacingXl,
  cssColorPrimary,
  cssColorLight,
  formUi,
} from '../../constants/globalcss';

export function ViewToggle({ useGrid, onToggle }) {
  return (
    <ToggleButtonGroup
      value={useGrid}
      exclusive
      onChange={onToggle}
      aria-label="Grid or list view"
      sx={{
        backgroundColor: '#f3f6fb',
        border: `1px solid ${colors.border.medium}`,
        borderRadius: '10px',
        p: '3px',
      }}
    >
      <ToggleButton value={true} aria-label="Grid view">
        <ViewModuleIcon />{' '}
        <Box sx={{ display: { sm: 'block', xs: 'none' }, ml: 1 }}>Grid</Box>
      </ToggleButton>
      <ToggleButton value={false} aria-label="List view">
        <ViewStreamIcon />
        <Box sx={{ display: { sm: 'block', xs: 'none' }, ml: 1 }}>List</Box>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

interface HomeMenuProps {
  classes: ReturnType<typeof useHomePageStyles>;
  sortedRequestTypes: IRequestType[];
  onMenuItemClick: (type: IRequestType) => void;
}

export function HomeMenu({
  sortedRequestTypes,
  onMenuItemClick,
}: HomeMenuProps) {
  const classes = useStyles();

  return (
    <Box className={classes.menuContainer}>
      <Typography
        variant="body1"
        sx={{
          color: colors.text.primary,
          fontSize: { md: '1.0625rem', xs: '1rem' },
          lineHeight: 1.5,
          marginBottom: cssSpacingLg,
          textAlign: 'center',
        }}
      >
        Please select what type of information you would like to submit
      </Typography>

      <Box className={classes.menuItemsContainer}>
        {sortedRequestTypes.map((type) => (
          <MenuItem
            key={type.id}
            text={type.name}
            icon={typeIconMap[type.name] || <DescriptionIcon />}
            onClick={() => onMenuItemClick(type)}
          />
        ))}
      </Box>
    </Box>
  );
}

function MenuItem(props: {
  text: string;
  icon: React.ReactNode;
  onClick: () => void;
}) {
  return (
    <Button
      onClick={props.onClick}
      variant="contained"
      fullWidth
      startIcon={props.icon}
      sx={{
        '&:hover': {
          backgroundColor: cssColorLight,
        },
        backgroundColor: cssColorPrimary,
        borderRadius: formUi.card.radius,
        color: colors.background.paper,
        fontSize: { md: '0.9375rem', xs: '0.875rem' },
        fontWeight: typography.fontWeight.bold,
        minHeight: 56,
        justifyContent: 'flex-start',
        minWidth: cssMinButtonWidth,
        paddingInlineStart: cssSpacingXl,
      }}
    >
      {props.text}
    </Button>
  );
}

const typeIconMap: Record<string, React.ReactNode> = {
  'Cash For Keys': <MonetizationOnIcon />,
  'Fee Approval': <ReceiptLongIcon />,
  'Fee Waiver': <AssignmentTurnedInIcon />,
  'HP Issue/Litigation': <GavelIcon />,
  'Lien Impairment': <WarningAmberIcon />,
  Modifications: <EditNoteIcon />,
  'Plan Objection': <DescriptionIcon />,
  'Property Preservation': <HomeRepairServiceIcon />,
  'Short Sale': <AccountBalanceIcon />,
  'Tax Advance': <ReceiptLongIcon />,
};
